export default __webpack_public_path__ + "static/aws-7dd80bda4160dbcc19e1c9811e22ab7f.png";